import {
  FileOutlined,
  CloudUploadOutlined,
  CheckCircleOutlined,
  LoadingOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  KeyOutlined
} from '@ant-design/icons';

import { type UploadItem } from '@/hooks/useUploader';
import { cn } from '@/lib/cn';

export const UploadInfo = ({ upload }: { upload: UploadItem }) => {
  return (
    <div className='text-content-caption flex flex-row flex-wrap gap-2 text-xs'>
      <div className='items-left bg-surface-disabled border-outline-disabled flex flex-row justify-center gap-1 rounded border px-2'>
        <FileOutlined /> <div>{((upload.file.size || upload.size || 0) / 1024).toFixed(0)}KB</div>
      </div>

      <div className='items-left bg-surface-disabled border-outline-disabled flex w-16 flex-row justify-center gap-1 rounded border px-2'>
        <CloudUploadOutlined /> <div>{upload.progress.toFixed(0)}%</div>
      </div>

      <div
        className={cn(
          'items-left bg-surface-disabled border-outline-disabled flex flex-row justify-center gap-1 rounded border px-2',
          {
            'border-green-200 bg-green-100 text-green-600 dark:border-green-800 dark:bg-green-700/15 dark:text-green-500':
              ['done', 'exists'].includes(upload.status),
            'bg-surface-disabled border-outline-disabled text-content-caption': upload.status === 'uploading',
            'border-yellow-200 bg-yellow-200 text-yellow-600 dark:border-orange-800 dark:bg-orange-700/15 dark:text-orange-400':
              upload.status === 'idle',
            'border-red-200 bg-red-100 text-red-600 dark:border-red-800 dark:bg-red-700/15 dark:text-red-500': [
              'aborted',
              'error'
            ].includes(upload.status)
          }
        )}
      >
        {upload.status === 'hashing' && (
          <>
            <KeyOutlined /> <div>Verificando arquivo</div>
          </>
        )}
        {['exists', 'done'].includes(upload.status) && (
          <>
            <CheckCircleOutlined /> <div>Upload completo</div>
          </>
        )}
        {upload.status === 'uploading' && (
          <>
            <LoadingOutlined spin /> <div>Enviando arquivo</div>
          </>
        )}
        {upload.status === 'idle' && (
          <>
            <ClockCircleOutlined spin /> <div>Aguardando envio</div>
          </>
        )}
        {upload.status === 'aborted' && (
          <>
            <CloseCircleOutlined /> <div>Excluindo upload</div>
          </>
        )}
        {upload.status === 'error' && (
          <>
            <CloseCircleOutlined /> <div>Falha no upload</div>
          </>
        )}
      </div>
    </div>
  );
};
